export const POPUP_HEIGHT_IN_PX = 416;
const MOBILE_VIEW_DYNAMIC_HEIGHT = 'calc(100vh - 132px)';
const MOBILE_VIEW_FILL_HEIGHT = '100%';

interface SearchBarDimensions {
  listboxMinHeight: 416 | string;
  paperHeight: 416 | string;
  popperHeight: 416 | string;
}

/**
 * Returns the styling dimensions for the search bar components based on the viewport size.
 *
 * @param {boolean} isSmallViewport Indicates if the viewport matches the small viewport breakpoint.
 *
 * @returns {SearchBarStyling}
 *   Object containing the dimensions for listbox, paper, and popper heights.
 */
export const getSearchBarDimensions = (isSmallViewport: boolean): SearchBarDimensions => {
  const listboxMinHeight = isSmallViewport ? MOBILE_VIEW_FILL_HEIGHT : POPUP_HEIGHT_IN_PX;
  const paperHeight = isSmallViewport ? MOBILE_VIEW_FILL_HEIGHT : POPUP_HEIGHT_IN_PX;
  const popperHeight = isSmallViewport ? MOBILE_VIEW_DYNAMIC_HEIGHT : POPUP_HEIGHT_IN_PX;

  return {
    listboxMinHeight,
    paperHeight,
    popperHeight,
  };
};
